import { getPlans } from '../../plans';

import { Permissions } from './permissions';
import {
    ACLVoter,
    CollectionsVoter,
    MessengersVoter,
    PageBlocksPublishVoter,
    PageBlocksVoter,
    PageStylingVoter,
    PagesVoter,
    PagePublishVoter,
    PageTemplatesVoter,
    PageThemesVoter,
    ProductsVoter,
    SubscriptionFormFieldVoter,
    UnlimitedPlanVoter,
    VersionVoter,
    WebsitesVoter,
} from './voters/impl';
import { loadACL } from './acl/loader';

export { AccessPermissionRequest } from './request';
export { AccessRequestError } from './requestError';
export { WebsitesVoter };

export const aclVoter = new ACLVoter(() => loadACL(getPlans()));

export const permissions = new Permissions(aclVoter, [
    new UnlimitedPlanVoter(),
    new VersionVoter({
        'ru-integrations': '<5.14',
    }),
    // new LinksVoter(),
    // new DesignVoter(),
    // new ProfileVoter(),
    // new ReviewsVoter(),
    new CollectionsVoter(),
    new MessengersVoter(),
    new ProductsVoter(),
    new WebsitesVoter(),
    new PagesVoter(),
    new PagePublishVoter(),
    new PageTemplatesVoter(),
    new PageThemesVoter(aclVoter),
    new PageStylingVoter(aclVoter),
    new PageBlocksVoter(aclVoter),
    new PageBlocksPublishVoter(aclVoter),
    new SubscriptionFormFieldVoter(),
]);
